import styled from 'styled-components';

import {Avatar, Button, List, message, notification, Grid} from 'antd';
import { AlertTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';
import moment from 'moment';

import {CompanyTypeIcon} from '../icons';
import {AlertTag} from "./AlertTag";
import companyIcon from '../assets/images/icons/company@2x.png';
import { SubmitReportButton } from './CustomForm';
import {
    currentToken,
    currentUser,
    isCompany, setUser,
} from '../features/user/userSlice';
import {useDispatch, useSelector} from 'react-redux';
import { CustomMoreLink } from './Common';
import {getPersonalInfo} from "../api/User";
import {useMemo} from "react";
const {useBreakpoint} = Grid

const TableContainer = styled.div`
  // margin-bottom: 20px;
  overflow: hidden;
`;

export const CardTitle = styled.div`
  position: relative;
  font-size: 18px;
  line-height: 18px;
  margin-top: 20px;
  font-weight: 600;
  color: #fff;
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`
const CompanyIconWrap = styled(FlexCenter)`
  img {
    margin-right: 3px;
  }
`

const projectWrapper = styled.div`
  width:100px;
  height:100px;
  color: #4B555E;
  font-size: 12px;
  line-height: 18px;
  border:1px solid red;
  float:left;
`
const CustomLink = styled(Link)`
  color:#fff;
  &:hover{
    color:#6ee6c6;
    text-decoration: underline;
  }
`

const Category = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #4B555E;
`

const Reward = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    margin-left: 10px;
  }
`

const ProjectCommonTable = ({ data, loading, title, pagination, type='home' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const user = useSelector(currentUser);
    const token = useSelector(currentToken);
    const dispatch = useDispatch();

  const _isCompany = useSelector(isCompany);
    const breakpoint = useBreakpoint();

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

  const titleSize = _isCompany ? '20%' : '18%';
  const categorySize = _isCompany ? '20%' : '18%';
  const descriptionSize = _isCompany ? '30%' : '20%';
  const bountySize = _isCompany ? '0' : '18%';

    const toAddReport = async (item) => {
        if (!token) {
            navigate('/login');
            return message.warning('Please login first');
        } else {
            if (!user.user.wallet_address || user.user.wallet_address === '') {
                const {code, data} = await getPersonalInfo();
                if (code === '10000') {
                    if (data.hacker.wallet_address) {
                        const user = JSON.parse(localStorage.getItem('user'));
                        user.user.wallet_address = data.hacker.wallet_address;
                        dispatch(setUser(user));
                        navigate('/addreport');
                    } else {
                        return notification.warning({
                            key: 'warning',
                            description: (
                                <span
                                    style={{
                                        fontSize: '16px',
                                    }}
                                >
                  Please set your wallet address before submitting your report.
                </span>
                            ),
                            btn: (
                                <Button
                                    size="small"
                                    style={{
                                        height: '32px',
                                        backgroundColor: '#18EAC4',
                                        borderColor: '#18EAC4',
                                        color: '#000',
                                        borderRadius: '6px',
                                    }}
                                    onClick={() => {
                                        notification.close('warning');
                                        navigate('/user?page=my_info', {state: {wallet_address: true}});
                                    }}
                                >
                                    Setting
                                </Button>
                            ),
                        });
                    }
                }
            } else {
                navigate(`/addreport?project=${item.name}&project_id=${item.id}`);
            }
        }
    };

  return (
    <TableContainer>
      {title ? <CardTitle>{title}
      <div style={{
        float:'right',
      }}>
        <CustomMoreLink
            to={`/bounties`}
          >
            + more
        </CustomMoreLink>
      </div>

      </CardTitle> : null}
      <List
        style={{
          fontFamily:'HelveticaNeueBold',
        }}
        className="report-list"
        itemLayout="horizontal"
        loading={loading}
        bordered={false}
        dataSource={data}
        pagination={pagination}
        split={true}
        renderItem={(item, index) => (
          <List.Item style={{padding: '16px 0',justifyContent:'left'}}>
            <div className="custom-home-project-avatar">
              <Avatar style={{width:'32px'}} src={item.logo} shape = 'square' size='default' />
            </div>
            <div className="custom-home-project-title" style={{minWidth:`${titleSize}`,marginLeft:'13px'}}>
              <CustomLink
                  to={`/bounties/${item.name}`}
                >
                  {item.name.length>15?item.name.substring(0,15)+'...':item.name}
                  {
                      isMobile && (
                          <Category>
                              {item.category.name.length>15?item.category.name.substring(0,15)+'...':item.category.name}
                          </Category>
                      )
                  }
              </CustomLink>
            </div>
              {
                  !isMobile && (
                      <div className="custom-home-project-type" style={{fontSize: '13px',minWidth:`${categorySize}`,fontFamily:'HelveticaNeueBold'}}>
                          <CompanyTypeIcon  />
                          {/* <span style={{
                color:'#4B555E',
                marginRight:'13px'
              }}>Type</span>  */}
                          {item.category.name}
                      </div>
                  )
              }
              {
                  !isMobile && (
                      <div className="custom-home-project-description" style={{fontSize: '13px',minWidth:`${descriptionSize}`,fontFamily:'SourceHanSansNormal',textAlign:'left',paddingLeft:'20px'}}>
                          {item.description.length > 40 ? item.description.substring(0, 40)+'...' : item.description}
                      </div>
                  )
              }
              {
                  !isMobile ? (
                      <div className="custom-home-project-reward" style={{
                          minWidth: `${bountySize}`,
                          width: '100%',
                          textAlign: 'right',
                      }}>
                          <span style={{color:'#4B555E', fontSize: '13px',}}>
                            Rewards up to &nbsp;
                          </span>
                          <span style={{
                              fontFamily:'SourceHanSansNormal'
                          }}>
                            <b>{item.reward_symbol}</b>
                              &nbsp;
                          {item.max_reward.toLocaleString(navigator.language)}
                        </span>
                      </div>
                  ) : (
                      <Reward>
                          <CustomLink to={`/bounties/${item.name}`}>
                              <b>{item.reward_symbol}</b>
                              &nbsp;
                              {item.max_reward.toLocaleString(navigator.language)}
                              <img width={8} src={require('../assets/images/icons/arrow-right.png')} alt=""/>
                          </CustomLink>
                      </Reward>
                  )
              }
            {!_isCompany && (<div className="custom-home-project-button" style={{
              width: '100%',
              textAlign: 'right'
              }}>
              <SubmitReportButton onClick={() => toAddReport(item)}>Submit a Report</SubmitReportButton>
            </div>)}

          </List.Item>
        )}
      />
    </TableContainer>
  );
};

export default ProjectCommonTable;
